export default "__VITE_ASSET__0fc77ddf__"